// Resolved state of a public invite page (§6.9). The hook derives exactly one of
// these from the GET response (or a token error), and the view switches on it.
//
//   loading    → still fetching the invite
//   valid      → a usable, pending invite → render the program + accept/decline
//   not_found  → 404: token doesn't exist          → "Convite não encontrado"
//   expired    → 422 (or expires_at in the past)   → "Convite expirado"
//   used       → 422 / non-pending: already answered → "Convite já utilizado"
//   declined   → the visitor just declined here     → recusa confirmation
//   error      → anything else (network/5xx)        → generic retry
export const INVITE_STATE = {
  LOADING: "loading",
  VALID: "valid",
  NOT_FOUND: "not_found",
  EXPIRED: "expired",
  USED: "used",
  DECLINED: "declined",
  ERROR: "error",
};

// Terminal (non-actionable) states — the ones that render a centered status
// screen instead of the invite card.
export const TERMINAL_INVITE_STATES = [
  INVITE_STATE.NOT_FOUND,
  INVITE_STATE.EXPIRED,
  INVITE_STATE.USED,
  INVITE_STATE.DECLINED,
  INVITE_STATE.ERROR,
];
